import { getApplicants, saveApplicant } from './Action'
import { applicantsSlice, initialState } from './Slice'

export type { ApplicantsState } from './Type'
export { saveApplicant, getApplicants }
export { initialState, applicantsSlice }

export default applicantsSlice.reducer
